import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { fetchData } from '../helpers/methods';

import StatusIndicator from './status-indicator';
import ButtonIcon from './button-icon';

const SearchCard = ({
	id,
	title,
	interfaceType = null,
	version = null,
	description = null,
	state = null,
	division = null,
	favourite = false,
	subscribed = false,
	objectType = 'SPECIFICATION',
	handleCardClick,
	showMetrics = false,
	metricLabel = '',
	metricValue = '',
}) => {
	const [isFavourite, setIsFavourite] = useState(favourite || false);
	const [isSubscribed, setIsSubscribed] = useState(subscribed || false);

	const truncateDescription = string => {
		const length = 250;
		if (string.length > length) {
			return `${string.slice(0, length)}...`;
		}
		return string;
	};

	const handleOptionContainerClick = e => {
		e.stopPropagation();
	};

	const addFavourite = () => {
		fetchData({
			uri: `/api/web/my/store/favourites/${id}/add`,
			method: 'POST',
		})
			.then(({ ok }) => {
				if (ok) {
					setIsFavourite(true);
				}
			});
	};

	const removeFavourite = () => {
		fetchData({
			uri: `/api/web/my/store/favourites/${id}/remove`,
			method: 'POST',
		})
			.then(({ ok }) => {
				if (ok) {
					setIsFavourite(false);
				}
			});
	};

	const subscribeUpdates = () => {
		fetchData({
			uri: `/api/web/my/store/watch/${id}/add`,
			method: 'POST',
		})
			.then(({ ok }) => {
				if (ok) {
					setIsSubscribed(true);
				}
			});
	};

	const unsubscribeUpdates = () => {
		fetchData({
			uri: `/api/web/my/store/watch/${id}/remove`,
			method: 'POST',
		})
			.then(({ ok }) => {
				if (ok) {
					setIsSubscribed(false);
				}
			});
	};

	return (
		<div
			className={`search-card is-${objectType.toLowerCase()}`}
			onClick={() => handleCardClick(id)}
			role="presentation"
		>
			<div className="search-card__status">
				<StatusIndicator state={state} />
			</div>
			<h4>{title}</h4>
			{description && (
				<p className="search-card__description">
					{truncateDescription(description)}
				</p>
			)}
			{division && (
				<div className="margin-bottom-8">
					<strong>Division: </strong>
					{division}
				</div>
			)}
			{(version || interfaceType) && (
			<div className="flex-row justify-space-between">
				<div>
					{interfaceType && (
						<>
							<strong>Type: </strong>
							{interfaceType}
						</>
					)}
				</div>
				<div>
					{version && (
						<>
							<strong>Version: </strong>
							{version}
						</>
					)}
				</div>
			</div>
			)}
			{showMetrics && (
				<div className="margin-top-8">
					<strong>
						{metricLabel}
						:
						{' '}
					</strong>
					{metricValue > 0 && metricValue < 1 && (
						Math.round(metricValue * 1000000) / 1000000
					)}
					{metricValue >= 1 && (
						Math.round(metricValue)
					)}
				</div>
			)}
			<div
				className="search-card__options-container"
				role="presentation"
				onClick={handleOptionContainerClick}
			>
				<div className="search-card__options border-top padding-8">
					<div className="margin-right-8 display-inline-block">
						{isFavourite ? (
							<ButtonIcon
								icon="heart-circle-minus"
								title="Remove from Favorites"
								type="success"
								onClick={() => removeFavourite()}
							/>
						) : (
							<ButtonIcon
								icon="heart-circle-plus"
								title="Add to Favorites"
								onClick={() => addFavourite()}
							/>
						)}
					</div>
					<div className="margin-right-8 display-inline-block">
						{isSubscribed ? (
							<ButtonIcon
								icon="bell"
								title="Unsubscribe"
								type="success"
								onClick={() => unsubscribeUpdates()}
							/>
						) : (
							<ButtonIcon
								icon="bell"
								title="Subscribe to Updates"
								onClick={() => subscribeUpdates()}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SearchCard;

SearchCard.propTypes = {
	id: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	interfaceType: PropTypes.string,
	version: PropTypes.string,
	description: PropTypes.string,
	state: PropTypes.objectOf,
	division: PropTypes.string,
	favourite: PropTypes.bool,
	subscribed: PropTypes.bool,
	objectType: PropTypes.string,
	handleCardClick: PropTypes.func.isRequired,
	showMetrics: PropTypes.bool,
	metricLabel: PropTypes.string,
	metricValue: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
};
